module.exports = __webpack_public_path__ + "media/img/auth/bexwebapp_bg-968d53e7be258904b9c085f9e366f9f9.png";